import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// Attach auth token from localStorage to every request
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('aatreya_admin_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Catalog
export const fetchKits = (params = {}) => client.get('/kits', { params }).then((r) => r.data);
export const fetchKit = (id) => client.get(`/kits/${id}`).then((r) => r.data);
export const fetchPractitioners = (params = {}) =>
  client.get('/practitioners', { params }).then((r) => r.data);
export const fetchTreatments = (params = {}) =>
  client.get('/treatments', { params }).then((r) => r.data);

// Appointments
export const createAppointment = (data) =>
  client.post('/appointments', data).then((r) => r.data);
export const fetchAppointments = () => client.get('/appointments').then((r) => r.data);

// Orders
export const createOrder = (data) => client.post('/orders', data).then((r) => r.data);
export const fetchOrders = () => client.get('/orders').then((r) => r.data);

// Contacts
export const createContact = (data) => client.post('/contacts', data).then((r) => r.data);
export const fetchContacts = () => client.get('/contacts').then((r) => r.data);

// Admin
export const fetchStats = () => client.get('/admin/stats').then((r) => r.data);

// Auth
export const loginAdmin = (email, password) =>
  client.post('/auth/login', { email, password }).then((r) => r.data);
export const fetchMe = () => client.get('/auth/me').then((r) => r.data);

export default client;
